/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

export type AccountWebhookWithSecretEventsItem = typeof AccountWebhookWithSecretEventsItem[keyof typeof AccountWebhookWithSecretEventsItem];


export const AccountWebhookWithSecretEventsItem = {
  white_label_subscriptionsubscribed: 'white_label_subscription.subscribed',
  white_label_subscriptionupgraded: 'white_label_subscription.upgraded',
  white_label_subscriptiondowngrade_scheduled: 'white_label_subscription.downgrade_scheduled',
  white_label_subscriptiondowngraded: 'white_label_subscription.downgraded',
  white_label_subscriptioncancellation_scheduled: 'white_label_subscription.cancellation_scheduled',
  white_label_subscriptioncancelled: 'white_label_subscription.cancelled',
  white_label_subscriptionrenewed: 'white_label_subscription.renewed',
  white_label_subscriptionexpired: 'white_label_subscription.expired',
  white_label_subscriptionpayment_failed: 'white_label_subscription.payment_failed',
} as const;
